export default "__VITE_ASSET__ByfZ2d6$__"